<script>
    import { czk } from '../../lib/currency';

    export let credits;
</script>

<style>
    .group {
        display: inline-flex;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 10px 10px 0;
    }

    .group .caption, .group .text {
        padding: 2px 8px;
    }

    .group .caption {
        font-weight: 500;
        background: #e4e4e4;
    }

    .group .text {
        background: #ececec;
        /* flex: 1; */
    }
</style>

<div>
    <div class="group">
        <span class="caption">Množství kreditů</span>
        <span class="text">{credits.cre_amount}</span>
    </div>
</div>

<div class="group">
    <span class="caption">Celková cena</span>
    <span class="text">{czk(credits.cre_price).format()}</span>
</div>